import Typography from '../typography';

const Subtitle = ({ children, ...props }) => (
  <Typography variant="h5" component="p" { ...props }>
    {children}
  </Typography>
);

export default Subtitle;
